// Loading — minimal Suspense fallback used by lazily-loaded routes.
// Kept tiny on purpose so it ships in the main bundle without bloating it.

export function Loading() {
  return (
    <div className="flex items-center justify-center min-h-[200px] text-sm text-muted-foreground">
      Loading…
    </div>
  );
}
